import { Container, Box, Typography, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import Page from "../../components/Page";
import AccountChangePassword from "../../sections/@dashboard/user/account/AccountChangePassword";

export default function ChangePassword() {
  const { t } = useTranslation();

  return (
    <Page title={t("params.change_password")}>
      <Container maxWidth="sm">
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Stack spacing={3} sx={{ width: 1 }}>
            <Typography variant="h4">{t("params.change_password")}</Typography>

            <Typography variant="body2" color="text.secondary">
              {t("params.change_password_hint")}
            </Typography>

            <AccountChangePassword />
          </Stack>
        </Box>
      </Container>
    </Page>
  );
}
